<div class="regenerate-shot-content">
  <form class="regenerate-form" [formGroup]="regenerateForm" (ngSubmit)="onSubmit()">
    <!-- AI Prompt -->
    <div class="form-group">
      <label class="form-label">
        AI Prompt<span class="required-field-indicator">*</span>
      </label>
      <app-text-area
        label="ai prompt"
        placeholder="Enter AI prompt for image generation"
        [control]="getControl('aiPrompt')"
        [isFormSubmitted]="isFormSubmitted"
        [rowsCount]="4"
        [max]="1000"
        class="form-textarea w-100"
      ></app-text-area>
    </div>

    <!-- Image Style -->
    <div class="form-group">
      <label class="form-label">
        Image Style<span class="required-field-indicator">*</span>
      </label>
      <div class="style-options">
        @for (style of imageStyles; track style.id) {
          <div
            class="style-option-card"
            [class.selected]="getControl('imageStyle').value === style.id"
            (click)="getControl('imageStyle').setValue(style.id)"
          >
            <div class="style-option-title">{{ style.name }}</div>
            <div class="style-option-desc">{{ style.description }}</div>
          </div>
        }
      </div>
    </div>

    <!-- AI Model -->
    <div class="form-group">
      <label class="form-label">
        AI Model<span class="required-field-indicator">*</span>
      </label>
      <app-select-input
        label="AI Model"
        placeholder="Select AI Model"
        [control]="getControl('aiModel')"
        [isFormSubmitted]="isFormSubmitted"
        [items]="aiModelList"
        valueKey="model_id"
        labelKey="model"
        [allowClear]="false"
        class="common-dark-dropdown-v1 w-100"
      ></app-select-input>
    </div>
  </form>

  <!-- Action Buttons -->
  <div class="action-buttons">
    <button type="button" class="discard-button-v1" (click)="onCancel()">
      Cancel
    </button>
    <button type="button" class="btn-secondary-filled" (click)="onSubmit()">
      Generate
    </button>
  </div>
</div>

